
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcTag as ObcTagElement} from '@oicl/openbridge-webcomponents/dist/components/tag/tag.js';
 
 
 

 
 export const ObcTag = createComponent({
   react: React,
   tagName: 'obc-tag',
   elementClass: ObcTagElement,
   events: {
     
   }
  });
 
 